import React, { useEffect, useState, useContext } from 'react';
import api from '../../../api/axiosConfig';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../../../styles/forms.css';
import '../../../styles/dashboard.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import safron from '../../assets/safron_Strip.jpeg'
import green from '../../assets/green_Strip.jpeg'
import qr from '../../assets/qr-aadhar.jpeg'
import logo from '../../../assets/Logo.png'
import { CheckBox } from '@mui/icons-material';
import gps from '../../assets/gps.png'

interface Animal {
  _id: string;
  type: string;
  species: string;
  breed: string;
  name: string;
  age: number;
  bloodGroup: string;
  // location: string;
  city: string;
  taluk: string;
  district: string;
  state: string;
  country: string;
  pin_code: string;
  praniAadharNumber: string;
  farmerId: string;
  animalImage: File | null;

}

interface AnimalFormData {
  type: string;
  species: string;
  breed: string;
  name: string;
  age: string;
  bloodGroup: string;
  // location: string;
  city: string;
  taluk: string;
  district: string;
  state: string;
  country: string;
  pin_code: string;
  animalImage: File | null;
}

interface GetAnimalsResponse {
  message: string;
  animals: Animal[];
}

interface FeedbackResponse {
  description: string;
  fileUrl: string;
  originalFileName: string;
}

const FarmerDashboard: React.FC = () => {
  const [animals, setAnimals] = useState<Animal[]>([]);
  const [isAddingAnimal, setIsAddingAnimal] = useState(false);
  const [editingAnimal, setEditingAnimal] = useState<Animal | null>(null);
  const [showHealthModal, setShowHealthModal] = useState(false);
  const [selectedAnimal, setSelectedAnimal] = useState<Animal | null>(null);
  const [feedback, setFeedback] = useState<FeedbackResponse[] | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [animalToDelete, setAnimalToDelete] = useState<string | null>(null);
  const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);
  const [showAadharModal, setShowAadharModal] = useState(false)
  const [farmer, setFarmer] = useState("");
  const [showDonorModal, setShowDonorModal] = useState(false);
  const [animalWeight, setAnimalWeight] = useState('');
  const [addHealthRecord, setAddHealthRecord] = useState(false);
  const [confirmDonor, setConfirmDonor] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [showBloodRequestModal, setShowBloodRequestModal] = useState(false);
  const [bloodQuantity, setBloodQuantity] = useState('');
  const [bloodReason, setBloodReason] = useState('');
  const [bloodImage, setBloodImage] = useState<File | null>(null);


  const [fetchedHealthRecord, setFetchedHealthRecord] = useState<{ description: string; fileUrl?: string } | null>(null);
  const [showHealthPopup, setShowHealthPopup] = useState(false);

  const [formData, setFormData] = useState<AnimalFormData>({
    type: '',
    species: '',
    breed: '',
    name: '',
    age: '',
    bloodGroup: '',
    city: '',
    taluk: '',
    district: '',
    state: '',
    country: '',
    pin_code: '',
    animalImage: null,
  });

  const context = useContext(AuthContext);
  const navigate = useNavigate();

  const fetchAnimals = async () => {
    try {
      const res = await api.farmer_api.get<GetAnimalsResponse>('/animal/get-animals');
      setAnimals(res.data.animals);
    } catch (error) {
      console.error('Error fetching animals:', error);
    }
  };

  useEffect(() => {
    fetchAnimals();
  }, []);

  const handleLogout = () => {
    if (context) {
      context.logout();
      navigate('/login');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const feedbackCardStyle = {
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '15px',
    marginTop:'15px',
    backgroundColor: '#f5f5f5',
  };

  const resetForm = () => {
    setFormData({
      type: '',
      species: '',
      breed: '',
      name: '',
      age: '',
      bloodGroup: '',
      city: '',
      taluk: '',
      district: '',
      state: '',
      country: '',
      pin_code: '',
      animalImage: null,
    });
    setIsAddingAnimal(false);
    setEditingAnimal(null);
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // Prepare FormData for multipart/form-data upload
      const data = new FormData();
      data.append("type", formData.type);
      data.append("species", formData.species);
      data.append("breed", formData.breed);
      data.append("name", formData.name);
      data.append("age", formData.age);
      data.append("bloodGroup", formData.bloodGroup);
      data.append("city", formData.city);
      data.append("taluk", formData.taluk);
      data.append("district", formData.district);
      data.append("state", formData.state);
      data.append("country", formData.country);
      data.append("pin_code", formData.pin_code);

      if (editingAnimal) {
        await api.farmer_api.put(`/animal/update/${editingAnimal._id}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
          // withCredentials: true,
        });
        setToast({ type: 'success', message: 'Animal updated successfully!' });
      } else {
        await api.farmer_api.post('/animal/add', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
          // withCredentials: true
        });
        setToast({ type: 'success', message: 'Animal registered successfully!' });
      }

      await fetchAnimals();
      resetForm();
    } catch (error) {
      console.error('Error saving animal:', error);
      setToast({ type: 'error', message: 'failed to Add Animal. Please try again.' });
    } finally {
      setTimeout(() => setToast(null), 5000)
    }
  };

  const handleDelete = (_id: string) => {
    setAnimalToDelete(_id); // open confirmation modal
  };


  const handleEdit = (animal: Animal) => {
    setEditingAnimal(animal);
    setFormData({
      type: animal.type,
      species: animal.species,
      breed: animal.breed,
      name: animal.name,
      age: animal.age.toString(),
      bloodGroup: animal.bloodGroup,
      city: animal.city,
      taluk: animal.taluk,
      district: animal.district,
      state: animal.state,
      country: animal.country,
      pin_code: animal.pin_code,
      animalImage: animal.animalImage,
    });
  };


  const handleDonorSubmit = async () => {
    if (!selectedAnimal || !animalWeight || !confirmDonor) {
      alert("Please complete the form properly.");
      return;
    }

    try {
      const donorData = new FormData();
donorData.append(
  "animalId",
  selectedAnimal._id
);
      donorData.append("weight", animalWeight);
      donorData.append("species", selectedAnimal.species);
      donorData.append("breed", selectedAnimal.breed);
      donorData.append("age", selectedAnimal.age.toString());
      donorData.append("bloodGroup", selectedAnimal.bloodGroup);
      donorData.append("location", `${selectedAnimal.city}, ${selectedAnimal.taluk}, ${selectedAnimal.district}, ${selectedAnimal.state}, ${selectedAnimal.country}, ${selectedAnimal.pin_code}`);
      const phone = context?.user?.owner_phone || context?.user?.user_phone || '';
      if (phone) donorData.append("owner_phone", phone);

      if (selectedAnimal.animalImage instanceof File) {
        donorData.append("image", selectedAnimal.animalImage);
      } else if (typeof selectedAnimal.animalImage === 'string') {
        donorData.append("imageUrl", selectedAnimal.animalImage);
      }

      if (addHealthRecord && fetchedHealthRecord) {
        donorData.append("addHealthRecord", "true");
        donorData.append("healthDescription", fetchedHealthRecord.description);
        if (fetchedHealthRecord.fileUrl) {
          donorData.append("healthFileUrl", fetchedHealthRecord.fileUrl);
        }
      }

      await api.admin_api.post("/donor/add", donorData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setToast({ type: "success", message: "Donor request submitted successfully!" });
    } catch (error) {
      console.error("Error submitting donor info:", error);
      setToast({ type: "error", message: "Failed to submit donor request." });
    } finally {
      resetDonorForm();
      setShowDonorModal(false);
      setAnimalWeight('');
      setAddHealthRecord(false);
      setConfirmDonor(false);
      setTimeout(() => setToast(null), 5000);
    }
  };



  const resetDonorForm = () => {
    setAnimalWeight('');
    setAddHealthRecord(false);
    setConfirmDonor(false);
    setFetchedHealthRecord(null);
    setShowHealthPopup(false);
  };


  const handleBloodTypingRequest = (animal: Animal) => {
    navigate('/labs', { state: { animal } }); // ✅ Send animal to LabList
  };

  const formatPraniAadhar = (aadhar: string) => {
    if (!aadhar) return null;

    const numericPart = aadhar.slice(0, -1);
    const lastChar = aadhar.slice(-1);

    // Group every 4 digits with a space (like: 1234 5678 9012 345)
    const spaced = numericPart.match(/.{1,4}/g)?.join(' ') || numericPart;

    return (
      <>
        {spaced}
        <span className="highlight-letter">{lastChar}</span>
      </>
    );
  };


const handleSubmitBloodRequest = async () => {
  if (
    !selectedAnimal ||
    !bloodQuantity ||
    !bloodReason
  ) {
    alert(
      'Please select an animal and enter quantity and reason'
    );

    return;
  }

  try {
    const payload = {
      // Important: the animal MongoDB _id.
      requestedAnimalId:
        selectedAnimal._id,

      quantity:
        bloodQuantity,

      reason:
        bloodReason,

      species:
        selectedAnimal.species || '',

      breed:
        selectedAnimal.breed || '',

      age:
        selectedAnimal.age || '',

      bloodGroup:
        selectedAnimal.bloodGroup || '',

      location: `${selectedAnimal.city}, ${selectedAnimal.taluk}, ${selectedAnimal.district}, ${selectedAnimal.state}, ${selectedAnimal.country}, ${selectedAnimal.pin_code}`,

      owner_phone:
        context?.user?.owner_phone ||
        context?.user?.user_phone ||
        '',

      ...(addHealthRecord &&
        fetchedHealthRecord && {
          healthDescription:
            fetchedHealthRecord.description,

          healthFileUrl:
            fetchedHealthRecord.fileUrl,
        }),
    };

    await api.admin_api.post(
      '/donor/addrequest',
      payload,
    );

    setToast({
      type: 'success',
      message:
        'Blood request submitted successfully!',
    });

    resetBloodRequestForm();
  } catch (error: any) {
    console.error(
      'Error submitting blood request:',
      error,
    );

    setToast({
      type: 'error',
      message:
        error?.response?.data?.message ||
        'Failed to submit blood request.',
    });
  } finally {
    setTimeout(
      () => setToast(null),
      5000,
    );
  }
};

  const resetBloodRequestForm = () => {
    setBloodQuantity('');
    setBloodReason('');
    setBloodImage(null);
    setAddHealthRecord(false);
    setFetchedHealthRecord(null);
  };





  return (
    <div className="center-page">
      {toast && (
        <div className={`global-toast ${toast.type}`}>
          <span>{toast.message}</span>
          <button className="toast-close" onClick={() => setToast(null)}>×</button>
        </div>
      )}

      <div className="dashboard-container">
        <div className="dashboard-header">
          {/* Burger Menu */}
          <div className="burger-menu" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </div>
          <div className="dashboard-logo">
            {/* <img src={logo} /> */}
          </div>
          <h2>Animal Owner Dashboard</h2>
          <button className="form-button1" onClick={handleLogout}>Logout</button>
        </div>
        <div className="dashboard-content">

          {/* Navigation Buttons (Desktop only) */}
          <div className="nav-buttons">
            <button className="form-button-contact-button" onClick={() => setIsAddingAnimal(true)}>
              Add New Animal
            </button>
          </div>

          {/* Mobile Sidebar Drawer Navigation */}
          {menuOpen && (
            <div className="dashboard-drawer-overlay" onClick={() => setMenuOpen(false)}>
              <div className="dashboard-drawer" onClick={(e) => e.stopPropagation()}>
                <div className="dashboard-drawer-header">
                  <h3>Menu</h3>
                  <button className="dashboard-drawer-close" onClick={() => setMenuOpen(false)}>×</button>
                </div>
                <div className="dashboard-drawer-body">
                  <button 
                    className="dashboard-drawer-item" 
                    onClick={() => { setIsAddingAnimal(true); setMenuOpen(false); }}
                  >
                    <span className="drawer-icon">➕</span> Add New Animal
                  </button>
                </div>
                <div className="dashboard-drawer-footer">
                  <button className="dashboard-drawer-logout" onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              </div>
            </div>
          )}

          {(isAddingAnimal || editingAnimal) && (
            <div className="animal-modal-overlay">
              <div className="animal-modal-content">
                <div className="animal-modal-header">
                  <h3 className="animal-modal-title">{editingAnimal ? 'Edit Animal Details' : 'Add New Animal'}</h3>
                  <button type="button" className="animal-modal-close" onClick={resetForm}>×</button>
                </div>
                <form onSubmit={handleSubmit} className="animal-modal-form">
                  <div className="animal-modal-grid">
                    
                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Type <span className="required">*</span></label>
                      <select
                        name="type"
                        className="animal-modal-select"
                        value={formData.type}
                        onChange={handleInputChange}
                        required
                      >
                        <option value='' disabled>Select type</option>
                        <option value="Vet">Vet</option>
                        <option value="Pet">Pet</option>
                      </select>
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Species <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="species"
                        value={formData.species}
                        onChange={handleInputChange}
                        placeholder="e.g. Dog, Cat, Cow"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Breed <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="breed"
                        value={formData.breed}
                        onChange={handleInputChange}
                        placeholder="e.g. Indian, Pit Bull"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Animal Name <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter animal name"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Age (years) <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="age"
                        type="number"
                        value={formData.age}
                        onChange={handleInputChange}
                        placeholder="Age"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Blood Group</label>
                      <input
                        className="animal-modal-input"
                        name="bloodGroup"
                        value={formData.bloodGroup}
                        onChange={handleInputChange}
                        placeholder="e.g. A, DEA 1.1"
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">City <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        placeholder="City"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Taluk <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="taluk"
                        value={formData.taluk}
                        onChange={handleInputChange}
                        placeholder="Taluk"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">District <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        placeholder="District"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">State <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        placeholder="State"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Country <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        placeholder="Country"
                        required
                      />
                    </div>

                    <div className="animal-modal-group">
                      <label className="animal-modal-label">Pin code <span className="required">*</span></label>
                      <input
                        className="animal-modal-input"
                        name="pin_code"
                        value={formData.pin_code}
                        onChange={handleInputChange}
                        placeholder="Pin code"
                        required
                      />
                    </div>

                  </div>
                  <div className="animal-modal-buttons">
                    <button type="button" className="animal-modal-btn secondary" onClick={resetForm}>
                      Cancel
                    </button>
                    <button type="submit" className="animal-modal-btn primary">
                      {editingAnimal ? 'Update' : 'Add'} Animal
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}


          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  {/* <th>Prani Aadhar</th> */}

                  <th>Type</th>
                  <th>Species</th>
                  <th>Breed</th>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Blood Group</th>
                  <th>Location</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {animals.map((animal) => (
                  <tr key={animal._id}>
                    <td data-label="Type">{animal.type}</td>
                    <td data-label="Species">{animal.species}</td>
                    <td data-label="Breed">{animal.breed}</td>
                    <td data-label="Name">{animal.name}</td>
                    <td data-label="Age">{animal.age}</td>
                    <td data-label="Blood Group">{animal.bloodGroup}</td>
                    <td data-label="Location">
                      {animal.city}, {animal.taluk},<br /> {animal.district}, {animal.state},<br /> {animal.country} - {animal.pin_code}
                    </td>

                    <td data-label="Actions" style={{ position: 'relative' }}>
                      <div className="dropdown-wrapper">
                        <button
                          className="form-button-action"
                          onClick={() => setOpenDropdown((prev) => (prev === animal._id ? null : animal._id))}
                        >
                          Actions ▾
                        </button>

                        {openDropdown === animal._id && (
                          <div>
                            <div className="dropdown-menu">
                              <button className='action-button edit' onClick={() => handleEdit(animal)}>Edit</button>

                              <button className='action-button edit' onClick={() => {
                                handleBloodTypingRequest(animal);
                                setOpenDropdown(null);
                              }}>
                                Blood Typing Request
                              </button>

                              <button className='action-button edit'
                                disabled={!animal.bloodGroup || animal.bloodGroup.trim() === ''}
                                title={!animal.bloodGroup ? 'Blood group is required' : ''}
                                style={{
                          opacity: !animal.bloodGroup ? 0.5 : 1,
                          cursor: !animal.bloodGroup ? 'not-allowed' : 'pointer'
                        }}
                                onClick={() => {
                                  setSelectedAnimal(animal);
                                  setShowDonorModal(true);
                                  setOpenDropdown(null);
                                }}
                              >
                                Become a Donor
                              </button>

                              <button className='action-button edit'
                                disabled={!animal.bloodGroup}
                                style={{
                          opacity: !animal.bloodGroup ? 0.5 : 1,
                          cursor: !animal.bloodGroup ? 'not-allowed' : 'pointer'
                        }}
                                onClick={() => {
                                  setSelectedAnimal(animal);
                                  setShowBloodRequestModal(true);
                                }}
                              >
                                Request Blood
                              </button>

                              <button className="action-button delete" onClick={() => handleDelete(animal._id)}>
                                Delete
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {showBloodRequestModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h3>Request Blood</h3>

                <div className="form-group">
                  <label className="form-label">Quantity (in ml):</label>
                  <input
                    type="text"
                    className="form-input"
                    value={bloodQuantity}
                    onChange={(e) => setBloodQuantity(e.target.value)}
                    placeholder="Enter quantity"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Reason:</label>
                  <textarea
                    className="form-textarea"
                    value={bloodReason}
                    onChange={(e) => setBloodReason(e.target.value)}
                    placeholder="Briefly state the reason..."
                  />
                </div>

                {/* <div className="form-group">
                  <label>Upload Image:</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setBloodImage(e.target.files?.[0] || null)}
                  />
                </div> */}

                {/* <div className="form-field checkbox-field" style={{ marginTop: '10px' }}>
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={addHealthRecord}
                      onChange={async () => {
                        const newChecked = !addHealthRecord;
                        setAddHealthRecord(newChecked);

                        if (newChecked && selectedAnimal) {
                          try {
                            const res = await api.farmer_api.get<FeedbackResponse[]>(`/feedback/${selectedAnimal.praniAadharNumber}`);
                            const record = res.data?.[0]; // assuming one record
                            if (record) {
                              setFetchedHealthRecord(record);
                              setShowHealthPopup(true);
                            } else {
                              setFetchedHealthRecord(null); // allow check even if none
                            }
                          } catch (err) {
                            console.error("Error fetching health record:", err);
                            setFetchedHealthRecord(null); // allow check even if error
                          }
                        } else {
                          setFetchedHealthRecord(null); // uncheck
                        }
                      }}
                    />{" "}
                    Add Previous Health Record
                  </label>
                </div> */}

                <div className="form-buttons">
                  <button
                    className="form-button"
                    onClick={handleSubmitBloodRequest}
                  >
                    Submit
                  </button>
                  <button
                    className="form-button cancel-button"
                    onClick={() => {
                      setShowBloodRequestModal(false);
                      resetBloodRequestForm();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}


          {showDonorModal && selectedAnimal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h3>Become a Donor - {selectedAnimal.name}</h3>
                <div className="form-group">
                  <label className="form-label">Animal Weight (in kg):</label>
                  <input
                    type="text"
                    className="form-input"
                    value={animalWeight}
                    onChange={(e) => setAnimalWeight(e.target.value)}
                    placeholder="Enter weight"
                    required
                  />
                </div>

                {/* <div className="form-field checkbox-field" style={{ marginTop: '10px' }}>
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={addHealthRecord}
                      onChange={async () => {
                        const newChecked = !addHealthRecord;
                        setAddHealthRecord(newChecked);

                        if (newChecked && selectedAnimal) {
                          try {
                            const res = await api.farmer_api.get<FeedbackResponse[]>(`/feedback/${selectedAnimal.praniAadharNumber}`);
                            const record = res.data?.[0]; // assuming one record
                            if (record) {
                              setFetchedHealthRecord(record);
                              setShowHealthPopup(true);
                            } else {
                              setFetchedHealthRecord(null); // allow check even if none
                            }
                          } catch (err) {
                            console.error("Error fetching health record:", err);
                            setFetchedHealthRecord(null); // allow check even if error
                          }
                        } else {
                          setFetchedHealthRecord(null); // uncheck
                        }
                      }}
                    />{" "}
                    Add Previous Health Record
                  </label>
                </div> */}



                <div className="form-field checkbox-field" style={{ marginTop: '10px' }}>
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={confirmDonor}
                      onChange={() => setConfirmDonor(!confirmDonor)}
                    /> Are you sure you want to become a donor?
                  </label>
                </div>

                <div className="form-buttons" style={{ marginTop: '20px' }}>
                  <button
                    className="form-button"
                    disabled={!confirmDonor}
                    title={!confirmDonor ? "You must confirm to proceed" : ""}
                    onClick={handleDonorSubmit}
                    style={{
                      opacity: !confirmDonor ? 0.5 : 1,
                      cursor: !confirmDonor ? 'not-allowed' : 'pointer'
                    }}
                  >
                    Submit
                  </button>

                  <button
                    className="form-button cancel-button"
                    onClick={() => {
                      resetDonorForm();
                      setShowDonorModal(false);
                    }}

                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}


          {animalToDelete && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h3>Confirm Deletion</h3>
                <p>Are you sure you want to delete this animal?</p>
                <div className="form-buttons">
                  <button
                    className="form-button"
                    onClick={async () => {
                      try {
                        await api.farmer_api.delete(`/animal/${animalToDelete}`);
                        await fetchAnimals();
                        setToast({ type: 'success', message: 'Animal deleted successfully' });
                      } catch (error) {
                        console.error('Error deleting animal:', error);
                        setToast({ type: 'error', message: 'Failed to delete animal' });
                      } finally {
                        setAnimalToDelete(null);
                        setTimeout(() => setToast(null), 5000);
                      }
                    }}
                  >
                    Yes, Delete
                  </button>
                  <button
                    className="form-button cancel-button"
                    onClick={() => setAnimalToDelete(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default FarmerDashboard;

